import { Route } from '@angular/router';
import { guestGuard, authGuard } from './common/guards/auth.guard';
import { superAdminGuard } from './common/guards/super-admin.guard';

export const appRoutes: Route[] = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./pages/login/login').then(m => m.LoginComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/main/app-layout').then(m => m.AppLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home').then(m => m.Home),
        children: [
          {
            path: 'dashboard',
            loadComponent: () =>
              import('./pages/dashboard/dashboard').then(
                m => m.DashboardComponent
              ),
            title: 'Dashboard',
          },
          {
            path: 'organization',
            children: [
              {
                path: 'permission',
                canActivate: [superAdminGuard],
                loadComponent: () =>
                  import('./pages/organization-permission/organization-permission').then(
                    m => m.OrganizationPermissionPage
                  ),
                title: 'Organization Permission',
              },
              {
                path: 'settings',
                canActivate: [superAdminGuard],
                children: [
                  {
                    path: 'group-settings',
                    loadComponent: () =>
                      import('./pages/group-settings/group-settings').then(
                        m => m.GroupSettingsPage
                      ),
                    title: 'Group Settings',
                  },
                  {
                    path: '',
                    redirectTo: 'group-settings',
                    pathMatch: 'full',
                  },
                ],
              },
              {
                path: '',
                redirectTo: 'imported-files',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'organization/imported-files',
            loadComponent: () =>
              import('./pages/imported-files/directory/imported-files-directory.page').then(
                m => m.ImportedFilesDirectoryPage
              ),
            title: 'Imported Files',
          },
          {
            path: 'organization/imported-files/:fileId',
            loadComponent: () =>
              import('./pages/imported-files/preview/imported-file-preview.page').then(
                m => m.ImportedFilePreviewPage
              ),
            title: 'Imported File Preview',
          },
          {
            path: 'spaces',
            loadComponent: () =>
              import('./pages/spaces/spaces').then(m => m.SpacesPage),
            title: 'All Spaces',
          },
          {
            path: 'spaces/:spaceId/folders/:folderId',
            loadComponent: () =>
              import('./pages/spaces/components/space-detail/space-detail').then(
                m => m.SpaceDetailComponent
              ),
            title: 'Space',
          },
          {
            path: 'spaces/:spaceId/folders/:folderId/tables/:tableId/rows/:rowId',
            loadComponent: () =>
              import('./pages/spaces/tables/task-detail/task-detail.page').then(
                m => m.TaskDetailPage
              ),
            title: 'Task Detail',
          },
          {
            path: 'spaces/:spaceId/folders/:folderId/tables/:tableId',
            loadComponent: () =>
              import('./pages/spaces/tables/table-grid/table-grid.page').then(
                m => m.TableGridPage
              ),
            title: 'Table',
          },
          {
            path: 'spaces/:spaceId/tables/:tableId/rows/:rowId',
            loadComponent: () =>
              import('./pages/spaces/tables/task-detail/task-detail.page').then(
                m => m.TaskDetailPage
              ),
            title: 'Task Detail',
          },
          {
            path: 'spaces/:spaceId/tables/:tableId',
            loadComponent: () =>
              import('./pages/spaces/tables/table-grid/table-grid.page').then(
                m => m.TableGridPage
              ),
            title: 'Table',
          },
          {
            path: 'spaces/:spaceId',
            loadComponent: () =>
              import('./pages/spaces/components/space-detail/space-detail').then(
                m => m.SpaceDetailComponent
              ),
            title: 'Space',
          },
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
        ],
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
